export default {
	
	analytics:{
		relocationService:[],
	}
}